/**
 * Initializes the Puhti script.
 * This function is responsible for starting the various functionalities of the script.
 */
const puhtiScriptInit = () => {
  classicEditorYouTube();
};

/**
 * Add css classes to classic editor youtube embeds.
 */
const classicEditorYouTube = () => {
  const query = document.querySelector(
    'p iframe[src^="https://www.youtube.com/embed/"]',
  );
  if (query !== null) {
    query.parentElement.classList.add("youtube-embed");
    query.classList.add("youtube-embed-iframe");
  }
};

// Initialize the Puhti script.
window.addEventListener("load", puhtiScriptInit);
